"use client";

import Button from "@/components/buttons";
import TextComponent from "../TextComponent";
import { useZStore } from "@/utils/z-store";
import Image from "next/image";
import CloseIcon from "./assets/close-icon.svg";

type Props = {
  title: string;
  description: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  onPrimaryClick: () => void;
  onSecondaryClick: () => void;
};

const OverwriteTemplateModal = ({
  title,
  description,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
}: Props) => {
  const { actions } = useZStore();
  return (
    <div className="relative flex h-[278px] w-full max-w-[628px] flex-col items-center justify-between rounded-[20px] bg-white px-[58px] py-[20px] shadow-lg">
      <button
        onClick={() => {
          actions.setMailchimpApiKeyModalClosed(true);
          actions.closeModal();
        }}
        className="absolute right-5 top-5 cursor-pointer hover:opacity-60"
        aria-label="Close success message"
        type="button"
      >
        <Image src={CloseIcon} alt="close icon" />
      </button>
      <div className="">
        <TextComponent
          type="h2"
          className="pt-[20px] text-center text-kd-secondary-1"
        >
          {title}
        </TextComponent>
        <TextComponent
          type="body"
          className=" mt-[10px] text-center text-kd-secondary-3"
        >
          {description}
        </TextComponent>
      </div>

      <div className="flex w-full justify-center space-x-4 pb-[20px]">
        <Button
          variant="secondary"
          className="w-full"
          onClick={onSecondaryClick}
        >
          <TextComponent type="button">{secondaryButtonText}</TextComponent>
        </Button>
        <Button variant="primary" className="w-full" onClick={onPrimaryClick}>
          <TextComponent type="button">{primaryButtonText}</TextComponent>
        </Button>
      </div>
    </div>
  );
};

export default OverwriteTemplateModal;
